<template>
  <div>
    <!-- Banner和标题 -->
    <ArticleTitle :meta-data="articleInfo.classData"></ArticleTitle>
    <!-- 主体 -->
    <el-row id="aam-marked-container-main">
      <!-- 左栏 -->
      <el-col :span="6">
        <div id="aam-marked-left-container">
          <AuthorAndMenuTree :author-data="articleInfo.authorData" :nav-tree="navTree"></AuthorAndMenuTree>
        </div>
      </el-col>
      <!-- 右栏 -->
      <el-col :span="18" style="padding-left: 15px">
        <div id="aam-marked-right-container">
          <MarkedAndCommentPanel :marked-data="articleInfo.classData.content"></MarkedAndCommentPanel>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import ArticleTitle from "@/views/article/share/components/ArticleTitle";
import AuthorAndMenuTree from "@/views/article/share/AuthorAndMenuTree";
import MarkedAndCommentPanel from "@/views/article/share/MarkedAndCommentPanel";

export default {
  name: "MarkdArticle",
  components: {
    MarkedAndCommentPanel,
    AuthorAndMenuTree,
    ArticleTitle,
  },
  props: {
    articleInfo: Object,
  },
  data() {
    return {
      navTree: [],
    }
  },
}
</script>